// src/components/sql/UpdateSnapVariant.jsx
import { useEffect } from "react";
import axios from "axios";
import "../../App.css";

const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/?$/, "/");

export default function UpdateSnapVariant({
  selectedVariant,   // object to edit (required)
  onSaved,           // () => void; parent refetches the list
  onClose,           // () => void; close modal
  userId,            // optional: enforce ownership on backend
  updatedVariant,    // { cardHTML, releaseDate, chanceOfGetting }
  setUpdatedVariant, // state setter from parent
}) {
  // preload form with selected values
  useEffect(() => {
    if (!selectedVariant) return;

    const cardHTML =
      selectedVariant.cardhtml ?? selectedVariant.cardHTML ?? "";
    const releaseISO = selectedVariant.releasedate ?? selectedVariant.releaseDate;
    const chance = selectedVariant.chanceofgetting ?? selectedVariant.chanceOfGetting ?? "";

    setUpdatedVariant({
      cardHTML,
      // normalize to YYYY-MM-DD (or empty string)
      releaseDate: releaseISO
        ? new Date(releaseISO).toISOString().split("T")[0]
        : "",
      chanceOfGetting: chance,
    });
  }, [selectedVariant, setUpdatedVariant]);

  if (!selectedVariant) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedVariant((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    // basic validation
    if (!updatedVariant.cardHTML?.trim()) {
      // simple guard; keep UI lightweight
      return;
    }
    if (
      updatedVariant.chanceOfGetting === "" ||
      isNaN(Number(updatedVariant.chanceOfGetting))
    ) {
      return;
    }

    // Resolve ids/fields coming from different casings
    const id = selectedVariant.id;
    const originalCardId =
      selectedVariant.cardid ?? selectedVariant.cardId ?? null;

    // Optional ownership guard via ?userId=...
    const qs = Number.isFinite(userId) ? `?userId=${userId}` : "";

    try {
      await axios.put(`${API_BASE}api/updateSnapVariant/${id}${qs}`, {
        cardHTML: updatedVariant.cardHTML.trim(),
        cardId: originalCardId,                          // keep original card
        releaseDate: updatedVariant.releaseDate || null, // send null if empty
        chanceOfGetting: Number(updatedVariant.chanceOfGetting),
      });

      if (typeof onSaved === "function") onSaved();
      if (typeof onClose === "function") onClose();
    } catch (err) {
      console.error("Error updating snap variant:", err);
    }
  };

  return (
    <div className="styled-info-modal">
      <h2 className="modal-title">
        Update {(selectedVariant.cardname ?? selectedVariant.cardName) || "Variant"}
      </h2>

      <input
        className="input"
        type="text"
        name="cardHTML"
        placeholder="Image URL"
        value={updatedVariant.cardHTML ?? ""}
        onChange={handleChange}
      />

      <input
        className="input"
        type="date"
        name="releaseDate"
        value={updatedVariant.releaseDate ?? ""}
        onChange={handleChange}
      />

      <input
        className="input"
        type="number"
        name="chanceOfGetting"
        placeholder="Chance of Getting (%)"
        value={updatedVariant.chanceOfGetting ?? ""}
        onChange={handleChange}
      />

      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <button className="button" onClick={handleUpdate}>
          Update Variant
        </button>
        <button
          className="button"
          style={{ background: "#444" }}
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
